export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "analysisPsd.worker.2f2ca3543c9bc165498c.worker.js");
}
